<template>
    <div>
        <div class="TopHead">
            <el-button v-throttle size="small" type="primary" icon="el-icon-back" @click="goBack"></el-button>
            <div class="TopHeadTit">审核</div>
        </div>
        <div class="TabList">
            <div class="TabItem" :class="{Act:TabIndex==1}" @click="TabIndex =1">评价表</div>
            <div class="TabItem" :class="{Act:TabIndex==2}" @click="TabIndex =2">客户信息</div>
        </div>
        <div v-show="TabIndex ==1">
            <div class="TableAllNum">总评分：<span class="Red">{{GetScoreNum}}</span></div>
            <div class="MaxHei">
                <div class="TableHead" v-for="(item,index) in NewItemList" :key="item.id">
                    <div class="TableDis">
                        <div class="TableTit">{{item.indicator}}</div>
                        <!-- <div class="TableQZ">权重{{item.weight}}</div> -->
                    </div>
                    <div class="TableFuTit">{{item.description}}</div>
                    <div class="TableRadio">
                        <label class="Radio" v-for="(i,num) in item.score+1">
                            <div class="RadioCer"><input type="radio" :name="'Radio'+item.id" :value="num"
                                    v-model="item.rating">{{num}}</div>
                        </label>
                    </div>
                    <div class="TableMsg" v-if="item.gl_yj">形式审查意见：{{item.gl_yj}}</div>
                    <div class="TableMsg" v-if="item.rating!=='' && item.rating!=item.score">
                        <el-input size="small" class="Wid" type="textarea" :rows="2" placeholder="请输入不是满分原因" v-model="item.opinion"></el-input>
                        <el-button v-throttle type="primary" size="small" icon="el-icon-microphone"
                            @click="ToggleAudio(item)"></el-button>
                    </div>
                </div>
                <div class="RemarkHead" v-if="RowData.identity">
                    <el-input class="Wid" type="textarea" :rows="3" placeholder="请输入综合意见及建议" v-model="Remark"></el-input>
                    <el-button v-throttle type="primary" size="small" icon="el-icon-microphone" @click="ToggleAudio('ZH')"></el-button>
                </div>
            </div>
            <div class="TableBtns">
                <el-button v-throttle size="small" @click="goBack">取消</el-button>
                <el-button v-throttle size="small" type="info" @click="SucData(0)">保存</el-button>
                <el-button v-throttle size="small" type="info" @click="ToggleZj" v-if="RowData.identity && RowData.leader_summary_required">总结</el-button>
                <el-button v-throttle size="small" type="primary" @click="SucData(1)">提交</el-button>
            </div>
        </div>
        <div v-show="TabIndex==2">
            <div>
                <nut-cell>
                    <div slot="title"><span class="Red">*</span>标题</div>
                    <div slot="desc">{{RowData.record_name}}</div>
                </nut-cell>
                <nut-cell v-for="item in RowData.group" :key="item.id">
                    <div slot="title"><span class="Red" v-if="item.is_required">*</span>{{item.field_label}}</div>
                    <div slot="desc" v-if="item.field_type == 'file'&&item.default_value">
                        <div @click="LockUrl(item.default_value)">
                            <span>文件</span>
                            <i class="el-icon-view"></i>
                        </div>
                    </div>
                    <div slot="desc" v-else-if="item.field_type == 'img_text'">
                        <div v-for="(items, is) in item.default_value" class="DisFlex">
                            <div @click="LockUrl(items.img_url)">
                                <span>图片({{is+1}})</span>
                                <i class="el-icon-view"></i>
                            </div>
                            <div>{{items.img_desc}}</div>
                        </div>
                    </div>
                    <div slot="desc" v-else>{{item.default_value}}</div>
                </nut-cell>
                <nut-cell v-if="RowData.gl_file.length>0">
                    <div slot="title"><span class="Red">*</span>添加附件</div>
                    <div slot="desc">
                        <div class="FuJianPos" v-for="(item, i) in RowData.gl_file" @click="LockUrl(item)">
                            文件{{ i + 1 }}
                        </div>
                    </div>
                </nut-cell>
            </div>
        </div>
        <nut-popup v-model="AudioBlon" position="bottom">
            <div class="AudioPos" v-if="isRecording">
                <img class="AudioImg" src="/static/play.gif" />
                <div class="AudioImgTxt">松开后，结束录音</div>
            </div>
            <div class="AudioBtn" 
                 @touchstart.prevent="AudioStart" 
                 @touchend.prevent="AudioStop"
                 @touchcancel.prevent="AudioStop(true)"
                 @contextmenu.prevent>
                {{isRecording ? '正在录音...' : '按住录音' }}
            </div>
            <!-- <div class="AudioBtn" @touchstart="AudioStart" @touchend="AudioStop">
                {{isRecording ? '正在录音...' : '按住录音' }}
            </div> -->
        </nut-popup>
        <Signature v-if="QianMingBlon" @Suc="QianMingSuc" @back="QianMingBlon = false"></Signature>
        <nut-popup v-model="ZJData.blon" :close-on-click-overlay="false">
            <div class="ZJHead">
                <div>总结：</div>
                <div class="ZJHeadDis">
                    <el-input class="Wid" type="textarea" :rows="3" placeholder="请输入综合意见及建议" v-model="RowData.zz_zj"></el-input>
                    <el-button v-throttle type="primary" size="small" icon="el-icon-microphone" @click="ToggleAudio('ZJ')"></el-button>
                </div>
                <div class="ZJHeadBtn">
                    <el-button v-throttle size="small" @click="$Tools.ResetData(ZJData)">取消</el-button>
                    <el-button v-throttle size="small" type="primary" @click="ZJSuc">提交</el-button>
                </div>
            </div>
        </nut-popup>
    </div>
</template>

<script>
    import Recorder from "recorder-core";
    import "recorder-core/src/engine/wav";
    export default {
        data() {
            return {
                loading: false,
                NewItemList: [],
                RowData: {
                    group: [],
                    gl_file: []
                },
                Remark: "",
                ApiType: "",
                TabIndex: 1,
                //录音
                ThisMsg:"",
                AudioBlon: false,
                isRecording: false,
                mediaRecorder: null,
                //签名
                QianMingBlon:false,
                QianMingUrl:"",
                TJType:"",
                //总结
                ZJData:{  //总结数据
                    blon:false,
                    id:"",
                    ruid:"",
                    zz_zj:"",
                },
            };
        },
        mounted(id) {
            this.ApiType = sessionStorage.getItem('ThisSysTem');
            this.GetDetail();
        },
        computed: {
            // 实时计算总评分，保留原有计算逻辑
            GetScoreNum() {
                let total = 0;
                if (this.NewItemList && this.NewItemList.length > 0) {
                    this.NewItemList.forEach(i => {
                        const rating = Number(i.rating) || 0;
                        const weight = Number(i.weight) || 0;
                        total += weight * rating;
                    });
                }
                return total;
            }
        },
        methods: {
            GetList(id) {
                var url = this.$route.params.type == "ZL" ? 'api/expert_portal/online/gradeData' :
                    'api/expert_portal/final/gradeData';
                this.$get(url, {
                    system_code: this.ApiType,
                    id: this.$route.params.id,
                }).then(res => {
                    if (res) {
                        this.NewItemList = res.data.map(i => {
                            if (i.text_content) {
                                i.text_content = JSON.parse(i.text_content)
                            }
                            i.rating = "";
                            i.opinion = "";
                            return i;
                        });
                    }
                })
            },
            GetDetail(id) {
                var url = this.$route.params.type == "ZL" ? '/api/expert_portal/online/detail' :
                    '/api/expert_portal/final/detail';
                this.$get(url, {
                    id: this.$route.params.id,
                    system_code: this.ApiType,
                }).then(res => {
                    if (res) {
                        if (res.data.group) {
                            var Data = JSON.parse(JSON.stringify(res.data));
                            Data.group = Data.group.map(item => {
                                if (item.field_options && typeof item.field_options === 'string') {
                                    try {
                                        item.field_options = JSON.parse(item.field_options);
                                        if (item.field_type == 'checkbox') {
                                            item.default_value = item.default_value ? item.default_value
                                                .split(",") : [];
                                        }
                                    } catch (e) {
                                        item.field_options = [];
                                    }
                                }
                                return item;
                            })
                            Data.gl_file = Data.gl_file ? Data.gl_file.split(",") : [];
                            this.RowData = Data;
                        }
                        if (res.data.rule.length > 0) {
                            this.Remark = res.data.opinion;
                            this.NewItemList = res.data.rule.map(i => {
                                if (i.text_content) {
                                    i.text_content = JSON.parse(i.text_content)
                                }
                                return i;
                            });
                        } else {
                            this.GetList(id)
                        }
                    }
                })
            },
            SucData(n,blon=true) {
                this.TJType = n;
                if(n==1&&blon){
                    this.QianMingBlon = true;
                    return;
                }
                var Arr = [];
                this.NewItemList.forEach(i => {
                    Arr.push({
                        id: i.score_rule_id || i.id,
                        rating: i.rating,
                        opinion: i.opinion,
                    })
                });
                var url = this.$route.params.type == "ZL" ? '/api/expert_portal/online/grade' :
                    '/api/expert_portal/final/grade';
                this.$post(url, {
                    id: this.RowData.id,
                    ruid: this.RowData.ruid,
                    opinion: this.Remark,
                    data: Arr,
                    is_tj: n
                }).then(res => {
                    if (res) {
                        this.$toast.text(res.msg);
                        if (n == 1) {
                            setTimeout(() => {
                                this.goBack();
                            }, 200)
                        }
                    }
                })
            },
            QianMingSuc(data){
                this.QianMingUrl = data;
                this.QianMingBlon = false;
                this.$post("api/expert_portal/final/signature", {
                    id: this.RowData.id,
                    base64: this.QianMingUrl,
                }).then(res => {
                    if (res) {
                        this.SucData(this.TJType,false);
                    }
                })
            },
            ToggleZj(){
                this.ZJData.id = this.RowData.id;
                this.ZJData.ruid = this.RowData.ruid;
                this.ZJData.blon = true;
            },
            ZJSuc(){
                this.ZJData.zz_zj = this.RowData.zz_zj;
                var url = this.$route.params.type == "ZL" ? '/api/expert_portal/online/zonjie' :
                    '/api/expert_portal/final/zonjie';
                this.$post(url,this.ZJData).then(res=>{
                    if(res){
                        this.$toast.text(res.msg);
                        this.$Tools.ResetData(this.ZJData)
                    }
                })
            },
            ToggleAudio(T) {
                this.ThisMsg = T;
                this.AudioBlon = !this.AudioBlon;
                if (this.AudioBlon) {
                    this.AudioOpen()
                }
            },
            async AudioOpen() {
                try {
                    await navigator.mediaDevices.getUserMedia({
                        audio: true
                    });
                    this.mediaRecorder = Recorder({
                        type: "wav",
                        sampleRate: 16000,
                        bitRate: 16,
                    });
                    this.mediaRecorder.open();
                } catch (err) {
                    console.error("无法打开录音权限:", err);
                }
            },
            // 开始录制
            AudioStart() {
                 if (!this.mediaRecorder) {
                    console.error("未打开录音");
                    this.$toast.text("录音初始化失败，请重试");
                    this.AudioBlon = false;
                    return;
                }
                try {
                    this.mediaRecorder.start();
                    this.isRecording = true;
                    console.log("已开始录音");
                } catch (err) {
                    console.error("开始录音失败:", err);
                    this.$toast.text("开始录音失败，请重试");
                }
            },
            // 结束录音
            AudioStop(isCancle) {
                if (!this.mediaRecorder) {
                    console.error("未打开录音");
                    return;
                }
                this.mediaRecorder.stop(
                    async (blob, duration) => {
                            const fileReader = new FileReader();
                            fileReader.readAsDataURL(blob);
                            fileReader.onload = () => {
                              const audioBase64 = fileReader.result;
                              const pureBase64 = audioBase64.split(',')[1];
                              // 3. 打印需求的所有数据到控制台
                              // console.log('===== 录音文件相关数据 =====');
                              // console.log('文件字节数（len）：', blob.size);
                              // console.log('完整Base64编码（不含格式头）：', pureBase64);
                              // console.log('原始Blob文件：', blob);
                              this.GetToken(audioBase64,blob.size);
                            };
                            this.isRecording = false;
                            this.AudioBlon = false;
                        },
                        (err) => {
                            console.error("结束录音出错：" + err);
                            this.mediaRecorder.close();
                            this.mediaRecorder = null;
                            this.isRecording = false;
                            this.AudioBlon = false;
                        }
                );
            },
            GetToken(base, len) {
                this.loading = this.$toast.loading('识别中...', {
                    duration: 0,
                    coverColor: "rgba(0,0,0,0.5)",
                });
                this.$post("/api/voice/BdRun",{
                    base64:base
                }).then(res => {
                    if (res) {
                         if(this.ThisMsg == 'ZH'){
                             this.Remark = res.data.result;
                         }else if(this.ThisMsg == 'ZJ'){
                             this.RowData.zz_zj = res.data.result;
                         }else{
                             this.ThisMsg.opinion = res.data.result;
                         }
                         this.$toast.text("语音识别成功");
                    }
                }).catch(err => {
                    console.error("语音识别失败:", err);
                    this.$toast.text("语音识别失败，请重试");
                }).finally(() => {
                    this.loading.hide();
                })
            },
            goBack() {
                this.$router.go(-1);
            },
            LockUrl(url) {
                window.open(this.$Tools.ServeUrl() + url)
            },
        }
    }
</script>

<style scoped>
    .DisFlex {
        display: flex;
        align-items: center;
    }
    .TopHead {
        padding: 10px;
        position: relative;
        border-bottom: 1px solid #ddd;
    }

    .TopHeadTit {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 18px;
        font-weight: bold;
    }

    .TabList {
        width: 100%;
        display: flex;
        align-items: center;
    }

    .TabItem {
        padding: 15px 0;
        flex: 1;
        text-align: center;
        font-size: 14px;
        font-weight: 700;
        border-bottom: 1px solid #ddd;
    }

    .TabItem.Act {
        border-bottom: 1px solid #d51938;
    }

    .TableAllNum {
        padding: 10px;
        font-weight: 700;
    }

    .MaxHei {
        height: 75vh;
        overflow-y: auto;
    }

    .TableHead {
        margin: 10px;
        border: 1px solid #ddd;
        border-radius: 5px;
    }

    .TableDis {
        border-bottom: 1px solid #ddd;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
    }

    .TableQZ {
        color: #d51938;
    }

    .TableFuTit {
        padding: 10px;
        border-bottom: 1px solid #ddd;
    }

    .TableRadio {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .Radio {
        width: 20px;
        padding: 10px;
    }

    .RadioCer {
        display: flex;
        align-items: center;
        gap: 5px;
    }

    .TableMsg {
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 10px;
        border-top: 1px solid #ddd;
    }

    .RemarkHead {
        display: flex;
        align-items: center;
        gap: 5px;
        margin: 10px;
    }

    .TableBtns {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 10px;
    }

    .AudioBtn {
        width: 80%;
        margin: 10px auto;
        padding: 12px 0;
        text-align: center;
        border-radius: 5px;
        background: #409EFF;
        color: #fff;
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
    }

    .AudioPos {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
    }

    .AudioImg {
        width: 10vw;
        border-radius: 10px;
    }

    .AudioImgTxt {
        font-size: 14px;
        color: #ffff;
        text-align: center;
        padding: 5px 0;
    }
    .ZJHead{
        width: 90vw;
        margin: 0 auto;
        border-radius: 5px;
        overflow: hidden;
        padding: 15px 10px;
    }
    .ZJHeadDis{
        margin-top: 5px;
        display: flex;
        align-items: center;
        gap: 5px;
    }
    .ZJHeadBtn{
        margin-top: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>